<div class="flex flex-col border-gray-700 rounded-lg border-solid border p-4 mt-4 wrap-break-word">
  <div class="flex items-center gap-2 mb-2">
    <i class="pi pi-sparkles text-base"></i>
    <h3 class="m-0">{{ 'project.steps.providerResults.aiSummary.title' | transloco }}</h3>
    <app-ai-generated-label [provenance]="summary()?.aiProvenance" />
  </div>

  @if (loading()) {
    <app-loading [size]="LoadingSize.SMALL" />
  } @else if (hasError()) {
    <div class="flex flex-col gap-2 py-4">
      <span class="text-sm opacity-80">
        {{ 'project.steps.providerResults.aiSummary.error' | transloco }}
      </span>
      <button type="button" class="btn-select-dark self-start" (click)="retry()">
        {{ 'common.retry' | transloco }}
      </button>
    </div>
  } @else {
    @if (summary(); as data) {
      <!-- Per-provider summaries -->
      <div class="flex flex-col gap-2">
        @for (provider of data.providerSummaries; track provider.providerId) {
          <div class="border-gray-700 rounded-md border-solid border overflow-hidden">
            <button
              type="button"
              class="w-full px-4 py-3 flex justify-between items-center text-left bg-second-level"
              (click)="toggleProvider(provider.providerId)"
            >
              <span class="font-semibold">{{ provider.providerName }}</span>
              <i
                class="pi text-xs"
                [ngClass]="
                  isProviderExpanded(provider.providerId) ? 'pi-chevron-up' : 'pi-chevron-down'
                "
              ></i>
            </button>

            @if (isProviderExpanded(provider.providerId)) {
              <div class="px-4 py-3 flex flex-col gap-3">
                <div>
                  <h4 class="m-0 mb-1 text-sm font-bold">
                    {{ 'project.steps.providerResults.aiSummary.strengths' | transloco }}
                  </h4>
                  <p class="m-0 text-sm whitespace-pre-line opacity-90">{{ provider.strengths }}</p>
                </div>
                <div>
                  <h4 class="m-0 mb-1 text-sm font-bold">
                    {{ 'project.steps.providerResults.aiSummary.weaknesses' | transloco }}
                  </h4>
                  <p class="m-0 text-sm whitespace-pre-line opacity-90">
                    {{ provider.weaknesses }}
                  </p>
                </div>
                <div>
                  <h4 class="m-0 mb-1 text-sm font-bold">
                    {{ 'project.steps.providerResults.aiSummary.assessment' | transloco }}
                  </h4>
                  <p class="m-0 text-sm whitespace-pre-line opacity-90">
                    {{ provider.assessment }}
                  </p>
                </div>
                @if (provider.kpiAssessment) {
                  <div>
                    <h4 class="m-0 mb-1 text-sm font-bold">
                      {{ 'project.steps.providerResults.aiSummary.kpiAssessment' | transloco }}
                    </h4>
                    <p class="m-0 text-sm whitespace-pre-line opacity-90">
                      {{ provider.kpiAssessment }}
                    </p>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>

      <!-- Overall summary -->
      <div class="mt-4">
        <h4 class="m-0 mb-1 font-bold">
          {{ 'project.steps.providerResults.aiSummary.overall' | transloco }}
        </h4>
        <p class="m-0 text-sm whitespace-pre-line opacity-90">{{ data.overallSummary }}</p>
      </div>

      <!-- Management conclusion -->
      <div class="mt-4">
        <h4 class="m-0 mb-1 font-bold">
          {{ 'project.steps.providerResults.aiSummary.managementConclusion' | transloco }}
        </h4>
        <p class="m-0 text-sm whitespace-pre-line opacity-90">{{ data.managementConclusion }}</p>
      </div>
    }
  }
</div>
